export function getFormattedUserName(name?: string) {
    return name?.startsWith('nlmk_') ? name?.replace('nlmk_', '') : name;
}